import { ignoreStylesClass, urlify, textHasUrl } from "utils/helpers"

export function VideoCallLocation({ address }: { address: string }) {
    function getUrlOrText() {
        const textWithOrWithoutUrl = urlify(address, "video-call-location")

        return ignoreStylesClass(textWithOrWithoutUrl)
    }

    return textHasUrl(address) ? (
        <div
            dangerouslySetInnerHTML={{
                __html: getUrlOrText(),
            }}
        />
    ) : (
        <>{address}</>
    )
}
